<template>
    <div>
        <section v-for="faq in faqs" :key="faq.key" class="ls-faq-list__section" :testid="faq.key">
            <a @click="toggleQuestion(faq.key)">
                {{ faq.title }}
                <lsIconChevronRight
                    :class="[
                        keys[faq.key] ? 'ls-faq-list__chevron-down' : '',
                        'ls-faq-list__chevron',
                    ]"
                />
            </a>
            <p v-if="keys[faq.key]">
                {{ faq.content }}
            </p>
        </section>
        <section class="ls-faq-list__section" testid="supportCall">
            <a @click="toggleQuestion('supportCall')">
                I have additional questions
                <lsIconChevronRight
                    :class="[
                        keys.supportCall ? 'ls-faq-list__chevron-down' : '',
                        'ls-faq-list__chevron',
                    ]"
                />
            </a>
            <div v-if="keys.supportCall" class="content">
                <div>
                    <LsIconPhoneCall :width="21" :height="45" :color="green" />
                    <div class="header-text">
                        <span class="header-text-top">Have additional questions?</span>
                        <span class="header-text-description">Call Support</span>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { FAQ_TREATMENT_QUESTIONS } from '@/constants';
import LsIconPhoneCall from '@/components/general/icons/lsIconPhoneCall.vue';
import lsIconChevronRight from '../icons/lsIconChevronRight.vue';

export default {
    components: {
        lsIconChevronRight,
        LsIconPhoneCall,
    },
    data() {
        return {
            faqs: FAQ_TREATMENT_QUESTIONS,
            keys: {
                whenStart: false,
                whenFirstService: false,
                canCancel: false,
                supportCall: false,
            },
        };
    },
    methods: {
        toggleQuestion(key) {
            const newValue = !this.keys[key];
            this.keys.whenStart = false;
            this.keys.whenFirstService = false;
            this.keys.canCancel = false;
            this.keys.supportCall = false;
            this.keys[key] = newValue;
        },
    },
};
</script>

<style lang="scss" scoped>
a {
    font-weight: bold;
    font-size: 0.875rem;
    display: flex;
    justify-content: space-between;
}
p {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    color: #798d84;
}
.ls-faq-list__chevron {
    max-height: 15px;
    width: 10px;
    margin-left: 8px;
    vertical-align: middle;
}
.ls-faq-list__chevron-down {
    transform: rotate(90deg);
}
.ls-faq-list__section {
    padding: 5px;
    user-select: none;
}

.themed-app {
    a {
        color: $theme-color-gray-darker;
    }
    p {
        color: $theme-color-gray-darker;
    }
}

.content {
    padding: 5px;
    margin-top: 5px;
    background: $theme-color-primary-light;
    > div {
        display: flex;
        padding: 0.5rem;

        span {
            font-size: 11pt;
        }
    }
    .header-text {
        margin-left: 1rem;
        @media (min-width: 300px) {
            max-width: 370px;
        }
        .header-text-top {
            display: flex;
        }
        .header-text-description {
            font-weight: 700;
        }
    }
}
</style>
